export default "__VITE_ASSET__DPS2LwlZ__"